/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var allowedFiltersByCollection = {
    electrical: ['siemens-panel', 'electrical-panel', 'breaker-panel', 'load-center', '100a-panel'],
    led: ['led', 'led-panel', 'led-high-bay', 'emergency-lighting', 'emergency-light', 'led-recessed-potlight', 'led-vapor-tight', 'wall-pack'],
    hardware: ['cabinet-hardware', 'handle', 'drawer-accessories', 'opening-system', 'cabinet-adhesive'],
    pluming: ['plumbing', 'braided-hoses'],
    'laminate-flooring': ['flooring', 'vinyl-flooring', 'engineered-hardwood-flooring', 'underlay', 'molding', 'stair'],
    'building-materials': ['tool-accessories', 'accessories', 'silicone', 'contact-glue', 'hot-melt-glues', 'pva-glues'],
    'door-windows': ['door-windows'],
    'security-camera-system': ['security-camera-system', 'ip-camera', 'tvi-camera', 'networking'],
    kitchen: ['kitchen-accessories', 'spice-rack', 'base-cabinets']
  };

  function getCollectionHandle() {
    var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function hasVisibleFilterItem(list) {
    return Array.prototype.some.call(list.querySelectorAll('.collection__filter-checkbox'), function (item) {
      return item.style.display !== 'none';
    });
  }

  function simplifyCollectionFilters() {
    var handle = getCollectionHandle();
    var allowedFilters = allowedFiltersByCollection[handle];

    if (!allowedFilters || !document.querySelector('.collection__filter-checkbox [data-tag]')) {
      return;
    }

    var allowedLookup = allowedFilters.reduce(function (memo, tagHandle) {
      memo[tagHandle] = true;
      return memo;
    }, {});

    document.querySelectorAll('.collection__filter-checkbox').forEach(function (item) {
      var input = item.querySelector('[data-tag]');
      if (!input) {
        return;
      }

      var tag = input.getAttribute('data-tag');
      var isActive = input.checked || item.classList.contains('is-active');
      item.style.display = allowedLookup[tag] || isActive ? '' : 'none';
    });

    document.querySelectorAll('.collection__filter-checkbox-list').forEach(function (list) {
      var group = list.closest('.collection__filter-group');
      if (group) {
        group.style.display = hasVisibleFilterItem(list) ? '' : 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', simplifyCollectionFilters);
  document.addEventListener('shopify:section:load', simplifyCollectionFilters);
  document.addEventListener('theme:loading:end', simplifyCollectionFilters);
  window.addEventListener('pageshow', simplifyCollectionFilters);
})();

(function () {
  var searchTypeOptions = [
    { value: 'Electrical', en: 'Electrical', fr: 'Électricité' },
    { value: 'Electrical Panel', en: 'Electrical Panels', fr: 'Panneaux électriques' },
    { value: 'LED', en: 'LED Lighting', fr: 'Éclairage DEL' },
    { value: 'LED Panel', en: 'LED Panels', fr: 'Panneaux DEL' },
    { value: 'LED High Bay', en: 'LED High Bay', fr: 'Luminaires high bay DEL' },
    { value: 'LED RECESSED POTLIGHT', en: 'LED Recessed Potlights', fr: 'Encastrés DEL' },
    { value: 'Emergency Lighting', en: 'Emergency Lighting', fr: 'Éclairage d’urgence' },
    { value: 'LED VAPOR TIGHT', en: 'LED Vapor Tight', fr: 'Luminaires étanches DEL' },
    { value: 'Wall Pack', en: 'Wall Packs', fr: 'Appliques murales extérieures' },
    { value: 'Cabinet Hardware', en: 'Cabinet Hardware', fr: 'Quincaillerie d’armoires' },
    { value: 'Handle', en: 'Cabinet Handles', fr: 'Poignées d’armoires' },
    { value: 'Hardware', en: 'Hardware', fr: 'Quincaillerie' },
    { value: 'Plumbing', en: 'Plumbing', fr: 'Plomberie' },
    { value: 'Braided Hoses', en: 'Braided Hoses', fr: 'Boyaux tressés' },
    { value: 'Door & Windows', en: 'Doors & Windows', fr: 'Portes et fenêtres' },
    { value: 'Security Camera System', en: 'Security Camera Systems', fr: 'Systèmes de caméras de sécurité' },
    { value: 'IP CAMERA', en: 'IP Cameras', fr: 'Caméras IP' },
    { value: 'Networking', en: 'Networking', fr: 'Réseautique' },
    { value: 'Tool Accessories', en: 'Tool Accessories', fr: 'Accessoires d’outils' },
    { value: 'MDF Molding', en: 'MDF Molding', fr: 'Moulures MDF' },
    { value: 'Flooring', en: 'Flooring', fr: 'Planchers' },
    { value: 'Vinyl Flooring', en: 'Vinyl Flooring', fr: 'Planchers vinyle' },
    { value: 'Kitchen Accessories', en: 'Kitchen Accessories', fr: 'Accessoires de cuisine' }
  ];

  function isFrenchPage() {
    var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return htmlLang.indexOf('fr') === 0 || /^\/fr(\/|$)/.test(window.location.pathname);
  }

  function updateSearchTypeLabel(select) {
    var filter = select.closest('.search-bar__filter');
    var activeLabel = filter ? filter.querySelector('.search-bar__filter-active') : null;
    var selected = select.options[select.selectedIndex];

    if (activeLabel && selected) {
      activeLabel.textContent = selected.textContent;
    }
  }

  function simplifySearchTypeDropdown() {
    var select = document.getElementById('search-product-type');

    if (!select || select.getAttribute('data-fj-simplified') === 'true') {
      return;
    }

    var isFr = isFrenchPage();
    var existingValues = Array.prototype.reduce.call(select.options, function (memo, option) {
      if (option.value) {
        memo[option.value] = true;
      }
      return memo;
    }, {});
    var firstOptionText = isFr ? 'Toutes les catégories' : 'All categories';

    select.innerHTML = '';
    var firstOption = document.createElement('option');
    firstOption.value = '';
    firstOption.selected = true;
    firstOption.textContent = firstOptionText;
    select.appendChild(firstOption);

    searchTypeOptions.forEach(function (item) {
      if (!existingValues[item.value]) {
        return;
      }

      var option = document.createElement('option');
      option.value = item.value;
      option.textContent = isFr ? item.fr : item.en;
      select.appendChild(option);
    });

    select.setAttribute('data-fj-simplified', 'true');
    select.addEventListener('change', function () {
      updateSearchTypeLabel(select);
    });
    updateSearchTypeLabel(select);
  }

  document.addEventListener('DOMContentLoaded', simplifySearchTypeDropdown);
  document.addEventListener('shopify:section:load', simplifySearchTypeDropdown);
  document.addEventListener('theme:loading:end', simplifySearchTypeDropdown);
  window.addEventListener('pageshow', simplifySearchTypeDropdown);
})();